module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('h2', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldTitleAddGroup[_vm.actualLanguage]))]), _vm._v(" "), _c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.profileData.profileInfo.email))])]), _vm._v(" "), _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldGroupName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupInfo.groupName),
      expression: "groupInfo.groupName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.groupInfo.groupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.groupInfo, "groupName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.groupInfo.groupName) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded btn-save",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.createGroup
    }
  }, [_vm._v(_vm._s(_vm.labelButtonConfirmed[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (_vm.displayMessage) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('h3', {
    staticClass: "font-w300 push-8"
  }, [_c('i', {
    staticClass: "fa fa-check fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.textDisplayMessage[_vm.actualLanguage]))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa3cde5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/group/CreateGroupForm.vue
// module id = 1526
// module chunks = 4